/**
 * Get Facebook Click ID (fbc) and Browser ID (fbp) from cookies.
 * Also generates fbc from fbclid URL parameter if cookie is not present
 *
 * fbc format: fb.1.{timestamp}.{fbclid}
 * fbp format: fb.1.{timestamp}.{random}
 *
 * @returns {{ fbc: string, fbp: string }}
 */
export function getFacebookIds() {
  const cookies = document.cookie.split('; ')

  // Get _fbc cookie
  let fbc = cookies.find((row) => row.startsWith('_fbc='))?.split('=')[1] || ''

  // Get _fbp cookie
  let fbp = cookies.find((row) => row.startsWith('_fbp='))?.split('=')[1] || ''

  // If no fbc cookie, try to generate from fbclid URL parameter
  if (!fbc) {
    const urlParams = new URLSearchParams(window.location.search)
    const fbclid = urlParams.get('fbclid')
    if (fbclid) {
      // Generate fbc in the format: fb.1.{timestamp}.{fbclid}
      const timestamp = Date.now()
      fbc = `fb.1.${timestamp}.${fbclid}`
    }
  }

  // If no fbp cookie, generate one in the format: fb.1.{timestamp}.{random}
  if (!fbp) {
    const timestamp = Date.now()
    const random = Math.floor(Math.random() * 2147483647)
    fbp = `fb.1.${timestamp}.${random}`
  }

  return { fbc, fbp }
}
